import useLoggedInUser from '@/composables/logged-in-user/logged-in-user';
import { aggregatorType, chartGroupByOption } from 'shared/constants.json';
import { edgeName } from '@/composables/grid-page/chart/utils';
import { textByLang } from 'shared/lib/language';
import { useI18n } from 'vue-i18n';

export default function useChartDisplay() {
  const { t } = useI18n();
  const { userLang } = useLoggedInUser();

  const metricUnit = (aggregation, source) => {
    switch (aggregation.aggregator) {
      case aggregatorType.count: {
        return t(`gridPageChart.${source}`);
      }
      case aggregatorType.sum: {
        return `${t('gridPageChart.sum', { edge: edgeName(aggregation, t, userLang.value) })}`;
      }
      case aggregatorType.avg: {
        return `${t('gridPageChart.avg', { edge: edgeName(aggregation, t, userLang.value) })}`;
      }
      case aggregatorType.min: {
        return `${t('gridPageChart.min', { edge: edgeName(aggregation, t, userLang.value) })}`;
      }
      case aggregatorType.max: {
        return `${t('gridPageChart.max', { edge: edgeName(aggregation, t, userLang.value) })}`;
      }
      case aggregatorType.countDistinct: {
        return `${t('gridPageChart.countDistinct', { edge: edgeName(aggregation, t, userLang.value) })}`;
      }
      default:
        return null;
    }
  };

  const getLabel = (option) => {
    if (option === null) {
      return t('general.none');
    }
    if (option.isProperty) {
      if (!option.property?.label) {
        return t('gridPageChart.deletedProperty');
      }
      return textByLang(option.property.label, userLang.value);
    }
    return t(`edges.${option.edge}`);
  };

  const getValueText = (option, key = 'aggregator', hiddenOptions = []) => {
    if (option === null) {
      return t('general.empty');
    }
    if (option[key] === chartGroupByOption.none) {
      return t('general.none');
    }
    if (option[key] === aggregatorType.count) {
      return t('groupByOption.count');
    }
    const label = getLabel(option);
    if (!hiddenOptions.includes(option[key])) {
      return `${label} (${t(`groupByOption.${option[key]}`)})`;
    }
    return label;
  };

  return { metricUnit, getValueText, getLabel };
}
